import saveConsentString from './saveConsentString';
import generateConsentString from '../utils/generateConsentString';
import { ConsentString } from 'consent-string';
import { logUsage } from 'owa-analytics-actions';
import {
    lazyGetServerOptionsForFeature,
    GdprAdsPrefsOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default async function loadGdprAdConsentString(): Promise<string> {
    // The vendorListVersion is the same as the vendorlist.json under the resource file
    // We put the version here so that we do not need to pull down the whole vendorlist.json every time when we load the Ad consent string
    const checkedInVendorListVersion = 137;

    const getServerOptionsForFeature = await lazyGetServerOptionsForFeature.import();
    const response = await getServerOptionsForFeature<GdprAdsPrefsOptions>(
        OwsOptionsFeatureType.GdprAdsPrefs
    );

    if (response == null || response.consentString == null || response.consentString == '') {
        return null;
    }

    let currentConsentString = response.consentString;

    const consentDataEncodedString = new ConsentString(currentConsentString);

    // Judge the saved consent data string is a valid Outlook.com consent string. CmpId must be 168. Otherwise, we will return null to let the caller reset the consent string value
    if (consentDataEncodedString.getCmpId() != 168) {
        logUsage('InvalidConsentDataString', { consentString: currentConsentString });
        return null;
    }

    // If the saved consent string's vendor list version is smaller than the check in vendor list version, we will re-generate and save a new consent string
    if (consentDataEncodedString.getVendorListVersion() < checkedInVendorListVersion) {
        logUsage('UpdateConsentDataVenorListVersion', { consentString: currentConsentString });
        currentConsentString = await generateConsentString(
            response.allowStorageAndAccess,
            response.allowPersonalization,
            response.allowAdSelectionDeliveryReporting,
            response.allowContentSelectionDeliveryReporting,
            response.allowMeasurement
        );
        await saveConsentString(currentConsentString);
    }

    return currentConsentString;
}
